import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { Categories } from '../business-entities/category-list-model';

@Injectable({
  providedIn: 'root'
})
export class CategoryDataService {

  constructor(private dataProvider: DataService) {

  }

  async getCategoryList(categoryObj: any): Promise<GenericResponse<Array<Categories>>> {
    return this.dataProvider.Post<GenericResponse<Array<Categories>>>(Urls.GetCategoryList, categoryObj)
      .toPromise();
  }

  deleteCategory(categoryId: number) {
    return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteCategory, categoryId)
      .toPromise();
  }

  activeInactiveCategory(categoryObj: any): Promise<GenericResponse<boolean>> {
    return this.dataProvider.Post<GenericResponse<boolean>>(Urls.ActiveInactiveCategory, categoryObj)
      .toPromise();
  }

  async getCategoryById(categoryId: number): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>
      (Urls.GetCategory, categoryId).toPromise();
  }

  async addEditCategory(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddEditCategory, model).toPromise();
  }
}
